/**
 * Reference Data API Service
 * Service for fetching reference data (availability schedules, payer options, etc.)
 */

import { apiClient } from '@/core/api/client';

export type ReferenceDataOption = {
  id: string;
  name: string;
  isActive?: boolean;
  sortOrder?: number;
};

export type ReferenceDataResponse = {
  data: ReferenceDataOption[];
  total: number;
};

/**
 * Reference Data API client
 */
export const referenceDataApi = {
  /**
   * Get all active availability schedules
   */
  async getAvailabilitySchedules(): Promise<ReferenceDataOption[]> {
    const response = await apiClient.get<ReferenceDataResponse>('/reference-data/availability-schedules');
    return response.data.data;
  },

  /**
   * Get all active payer options
   */
  async getPayerOptions(): Promise<ReferenceDataOption[]> {
    const response = await apiClient.get<ReferenceDataResponse>('/reference-data/payer-options');
    return response.data.data;
  },
};

